module.exports = __webpack_public_path__ + "img/bgAwardCertificate.75fb6340.png";